import { AnthropicModelFeatureMap } from "./anthropicTypes";
import { ChatCompletionsModelFeatureMap } from "./chatCompletionsTypes";
import { Model } from "./Model";
import { OpenAiChatModelFeatureMap } from "./openAiTypes";

export type ModelFeatures = {
  /**
   * Model identifier sent to the provider API (the wire name).
   */
  name: string;
  /**
   * User facing name for this model that appears in product
   */
  label: string;
  /**
   * Model requires data retention by the model provider. Orgs must opt in via
   * the `allowDataRetentionModels` magic setting before it can be used; see
   * the server's `magic/providers/utils/dataRetentionModels.ts` for enforcement.
   */
  requiresDataRetention: boolean;
};

export const ModelFeatureMap = {
  ...AnthropicModelFeatureMap,
  ...OpenAiChatModelFeatureMap,
  ...ChatCompletionsModelFeatureMap,
} satisfies Record<Model, ModelFeatures>;

/**
 * Reverse of `ModelFeatureMap[model].name`: maps a provider wire name (e.g.
 * `moonshotai/Kimi-K2.7-Code`) back to its `Model` enum member, or null for a
 * custom/gateway deployment whose wire name we don't recognize.
 */
export function modelFromWireName(wireName: string): Model | null {
  return (
    Object.values(Model).find(
      (model) => ModelFeatureMap[model].name === wireName,
    ) ?? null
  );
}
